<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10RwczO/tc-custom/9781504084840.jpg?1704888697569" alt="This image is the cover for the book Threats and Promises"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Threats and Promises
      </h1>
      <p class="bookDescription body article font2">
        <b>She has a new look, a new man, and a past that’s not her own. The <i>New York Times</i>–bestselling author delivers a chilling romantic thriller.</b><br/>  <br/> After her estranged brother dies, Lauren Stevenson inherits his substantial legacy, allowing her to finally fix a medical condition that’s plagued her all her life. The results of the plastic surgery are nothing less than astounding. In the mirror, Lauren sees a whole new person.<br/>  <br/> But that’s just the beginning. The shop Lauren has opened in Boston with her best friend is an instant success, and she’s even bought a farmhouse that she can’t wait to renovate. The only thing missing in her life is romance—until Matt Kruger shows up outside of her shop.<br/>  <br/> A friend of her late brother, Matt is in town on business. The rugged builder is everything Lauren has ever dreamed about, and they embark on a whirlwind romance. Only, strange things begin happening to Lauren—a garage door misses her by inches, a vicious dog appears out of nowhere, and things in the house seem to have been moved. With danger appearing around every corner, Lauren is convinced she’s being stalked. <br/>  <br/> Driven by vengeance, someone has set their sights on Lauren—or who they think she is—and they’re getting closer and closer . . .<br/>  <br/><b>Praise for Barbara Delinsky</b><br/>  <br/> “One of today’s quintessential authors of contemporary fiction . . . Delinsky is a joy to read . . . Women’s fiction at its very finest.” —<i>Romantic Times</i><br/>  <br/> “[An author] of sensitivity and style.” —<i>Publishers Weekly</i><br/>  <br/> “Delinsky is truly an author for all seasons.” —<i>Rave Reviews</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Barbara Delinsky
      </h2>
      
      <p class="authorDescription body article"> Barbara Delinsky is the author of more than twenty-two <I>New York Times</I>&ndash;bestselling novels. Her books have been published in thirty languages, with over thirty-five million copies in print worldwide. A lifelong New Englander, Delinsky currently lives in Massachusetts with her husband. She is a passionate photographer, an avid tennis player, a drop-all-when-they-call mom and Grammi, and a confidante to friends of all stripes. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f8ca68c